export const segmentTemplates = {
  home_banner_segments: {
    segment_type: "home_banner_segments",
    segment: {
      banner_image_url: "",
      banner_header_top_text: "",
      banner_header_text: "",
      banner_sub_header_text: "",
      buttons: [{ label: "", value: "" }],
    },
  },
  value_segments: {
    segment_type: "value_segments",
    segment: {
      header_text: "",
      value_image_url: "",
      value_image_media_id: "",
      style: "",
      cards: [
        {
          icon: "",
          icon_id: "",
          header_text: "",
          description: "",
        },
      ],
    },
  },
  collection_segments: {
    segment_type: "collection_segments",
    segment: {
      header_text: "",
      image_url: "",
      image_media_id: "",
      style: "",
      cards: [
        {
          icon: "",
          icon_id: "",
          header_text: "",
          description: "",
        },
      ],
    },
  },
  split_segments: {
    segment_type: "split_segments",
    segment: {
      header_text: "",
      style: "",
      cards: [
        {
          icon: "",
          icon_id: "",
          header_text: "",
          description: "",
        },
      ],
    },
  },
  contact_us_segments: {
    segment_type: "contact_us_segments",
    segment: {
      // contact_email: "",
      // contact_name: "",
      // query_type: "",
      header_text: "",
      subheader_text: "",
      contact_phone: [""],
      contact_email: [""],
      address: [""],
    },
  },

  number_scroll_segments: {
    segment_type: "number_scroll_segments",
    segment: {
      segment_header_text: "",
      scroll_numbers: [{ number_value: "", text: "" }],
    },
  },
  description_segments: {
    segment_type: "description_segments",
    segment: {
      header_text: "",
      description: "",
      style: "",
    },
  },
  banner_segments: {
    segment_type: "banner_segments",
    segment: {
      banner_image_url: "",
      banner_header_text: "",
      banner_sub_header_text: "",
      banner_image_media_id: "",
      buttons: [{ label: "", value: "" }],
    },
  },
  award_segments: {
    segment_type: "award_segments",
    segment: {
      header_text: "",
      subheader_text: "",
      segments: [{ icon: "", description: "" }],
    },
  },
  video_segments: {
    segment_type: "video_segments",
    segment: {
      header_text: "",
      subheader_text: "",
      video_url: "",
      bottom_description: "",
    },
  },
  scroll_segments: {
    segment_type: "scroll_segments",
    segment: {
      segment_header_text: "",
      scroll_images: [{ image_url: "", image_id: "", link: "" }],
    },
  },
  solution_segments: {
    segment_type: "solution_segments",
    segment: {
      header_text: "",
      subheader_text: "",
      image_url: "",
      segments: [
        {
          header_text: "",
          description: "",
          image_url: "",
        },
      ],
    },
  },
  code_segments: {
    segment_type: "code_segments",
    segment: { html_code: "" },
  },
  blog_segments: {
    segment_type: "blog_segments",
    segment: {
      header_text: "",
      quick_filters: [{ label: "", value: "" }],
      static_blogs: [],
      dynamic_blogs: "",
    },
  },
  faq_segments: {
    segment_type: "faq_segments",
    segment: {
      header_text: "",
      style: "",
      faqs: [
        {
          question_text: "",
          answer_text: "",
        },
      ],
    },
  },
  twocolumn_segments: {
    segment_type: "twocolumn_segments",
    segment: {
      header_text: "",
      column_one_content_type: "",
      column_one_text: "",
      column_one_image_url: "",
      column_one_image_id: "",
      column_two_content_type: "",
      column_two_text: "",
      column_two_image_url: "",
      column_two_image_id: "",
      style: "",
    },
  },
  twocolumnscroll_segments: {
    segment_type: "twocolumnscroll_segments",
    segment: {
      style: "",
      header_text: "",
      list: [
        {
          header_text: "",
          column_one_content_type: "",
          column_one_text: "",
          column_two_content_type: "",
          column_two_image_url: "",
          column_two_image_id: "",
        },
      ],
    },
  },
  pressrelease_segments: {
    segment_type: "pressrelease_segments",
    segment: {
      header_text: "",
      quick_filters: [
        {
          label: "",
          value: "",
        },
      ],
      static_pressrelease: [""],
      dynamic_pressrelease: "",
    },
  },
  podcast_segments: {
    segment_type: "podcast_segments",
    segment: {
      header_text: "",
      quick_filters: [
        {
          label: "",
          value: "",
        },
      ],
      static_podcasts: [""],
      dynamic_podcasts: "",
    },
  },
  people_segments: {
    segment_type: "people_segments",
    segment: {
      people_list: [""],
    },
  },
  newsletter_segments: {
    segment_type: "newsletter_segments",
    segment: {
      header_text: "",
    },
  },
  news_segments: {
    segment_type: "news_segments",
    segment: {
      header_text: "",
      quick_filters: [
        {
          label: "",
          value: "",
        },
      ],
      static_news: [""],
      dynamic_news: "",
    },
  },
  experience_segments: {
    segment_type: "experience_segments",
    segment: {
      header_text: "",
      style: "",
      cards: [
        {
          icon: "",
          icon_id: "",
          header_text: "",
          description: "",
        },
      ],
    },
  },
  cookies_segments: {
    segment_type: "cookies_segments",
    segment: {
      list: [
        {
          label: "",
          value: "",
        },
      ],
    },
  },
};
